import axios from 'axios'
import convertUser from '@/api/converters/user'
import sortAlphabetically from '@/functions/sortAlphabetically'

/**
 * Get list of coachees
 */
function getList () {
  return axios
    .get('coachees/')
    .then(response => response.data
      .map(convertUser)
      .sort((a, b) => sortAlphabetically(a.profile.name, b.profile.name))
    )
}

/**
 * Get coachee details
 * @param {Number} id Coachee ID
 */
function getSingle (id) {
  return axios
    .get(`coachees/${id}/`)
    .then(response => convertUser(response.data))
}

/**
 * Approve coachee by admin
 * @param {Number} id Coachee ID
 */
function approve (id) {
  return axios
    .get(`coachees/${id}/approve/`)
}

/**
 * Update coachee profile
 * @param {Number} id Profile ID
 * @param {Object} data Form data
 * @param {String} data.email Email address
 * @param {String} data.firstName First name
 * @param {String} data.lastName Last name
 * @param {String} data.phone Phone number
 * @param {String} data.phoneMobile Mobile phone number
 * @param {String} data.school Name of school
 * @param {Number} data.position ID of position type
 * @param {Number} data.schoolType ID of school type
 */
function update (id, data) {
  return axios
    .post(`coachees/${id}/edit/`, {
      email: data.email,
      first_name: data.firstName,
      last_name: data.lastName,
      telephone: data.phone,
      mobile: data.phoneMobile,
      job_title: data.position,
      school: data.school,
      school_type: data.schoolType
    })
}

/**
 * Delete coachee account
 * @param {Number} id Coachee ID
 */
function deleteAccount (id) {
  return axios
    .delete(`coachees/${id}/`)
}

export default {
  getList,
  getSingle,
  approve,
  update,
  deleteAccount
}
